export default {
  ctrl: {
    save: "Shrani",
    cancel: "Prekliči",
    search: "Išči",
    size: "Velikost",
    file: "Datoteka",
    timestamp: "Čas",
    name: "Ime",
    user: "Uporabnik",
    close: "Zapri",
    confirm: "Potrdi",
    error: "Prišlo je do napake!",
    errorCode: "Koda napake",
    remove: "Odstrani",
    selectCompetition: "Izberite tekmovanje",
    status: "Status",
    add: "Dodaj",
    language: "Jezik",
    change: "Spremeni",
    successfullySaved: "Uspešno shranjeno",
    export: "Izvozi",
    delete: "Izbriši",
    total: "Skupno",
    submit: "Oddaj",
    next: "Naprej",
    back: "Nazaj",
    ok: "Ok",
    select: "Izberi",
    edit: "Uredi"
  },
  dashboard: {
    title: "Nadzorna plošča",
    shirts: "Majice",
    competitionStart: "Začetek tekmovanja",
    competitionEnd: "Konec tekmovanja"
  },
  lang: {
    'sl-SI': "Slovenščina",
    'en-US': "Angleščina",
    'hr-HR': "Hrvaščina"
  },
  langNative: {
    'sl-SI': "Slovensko",
    'en-US': "English",
    'hr-HR': "Hrvatski"
  },
  forms: {
    required: "Obvezno polje",
    invalidemail: "Neveljavna e-pošta"
  },
  login: {
    title: "Prijava",
    incorrect: "Vaš e-naslov ali geslo je napačno",
    confirmationError: "Prišlo je do napake pri potrjevanju vašega e-poštnega naslova.",
    confirmed: "E-poštni naslov potrjen. Sedaj se lahko prijavite.",
    forgotPassword: "Pozabil sem geslo"
  },
  registration: {
    title: "Registracija",
    required: "Zahtevano polje",
    invalidEmail: "Neveljavna e-pošta",
    passwordMismatch: "Gesli se ne ujemata",
    passwordLength: "Geslo mora biti dolgo vsaj 6 znakov",
    passwordNumerical: "Geslo mora vsebovati vsaj eno števko",
    registrationSuccessful: "Registracija je bila uspešna. Preverite vaš e-poštni nabiralnik (tudi nezaželjeno pošto) za potrditveno sporočilo.",
    error: "Prišlo je do napake pri vaši registraciji."
  },
  "password-reset": {
    title: "Ponastavitev gesla",
    reset: "Ponastavi",
    message: "Povezava za ponastavitev gesla je bila poslana na naslov"
  },
  "new-password": {
    title: "Sprememba gesla",
    changeError: "Prišlo je do napake pri ponastavljanju gesla.",
    changed: "Geslo je bilo uspešno spremenjeno. Sedaj se lahko prijavite.",
    change: "Spremeni geslo"
  },
  competitors: {
    title: "Tekmovalci",
    firstName: "Ime",
    lastName: "Priimek",
    department: "Gasilska enota",
    gender: "Spol",
    email: "E-pošta"
  },
  applications: {
    title: "Prijave",
    profileNotFilled: "Izpolniti morate vsa polja v profilu",
    assignCategories: "Dodeli kategorije",
    clearCategories: "Počisti kategorije",
    assignCategoriesConfirmation: "Ali želite dodeliti kategorije?",
    clearCategoriesConfirmation: "Ali želiti počistiti dodeljene kategorije?"
  },
  application: {
    competition: "Tekmovanje",
    title: "Ime ekipe",
    type: "Tip prijave",
    category: "Kategorija",
    unassigned: "Nedodeljena",
    individual: "Posameznik",
    tandem: "Dvojica",
    relay: "Ekipa",
    code: "Koda",
    email: "E-pošta",
    remarks: "Opombe",
    payment: "Plačilo",
    invoiceForDepartment: "Račun na društvo",
    invoiceAddress: "Naslov za račun",
    taxNumber: "Davčna št.",
    amount: "Vsota",
    reference: "Sklic",
    confirmations: "Potrdila",
    events: "Dogodki",
    competitors: "Tekmovalci",
    confirmPayment: "Potrdi plačilo",
    confirmPaymentText: "Ali želite potrditi plačilo?",
    new: "Nova prijava",
    summary: "Povzetek",
    price: "Cena",
    cantAddCompetitor: "Tega tekmovalca ni v sistemu oz. še nima izpolnjenega profila.",
    noCycle: "Prijave za izbrano tekmovanje so trenutno zaprte.",
    submitTerms: "Z oddajo tega obrazca se strinjate, da organizator lahko objavi in obdeluje vaše osebne podatke za potrebe tekmovanja skladno z zakonom. Podatki se hranijo pri organizatorju tekmovanja.",
    failed: "Prišlo je do napake pri dodajanju prijave.",
    duplicateError: "Prijava s temi tekmovalci že obstaja.",
    duplicateTitleError: "Prijava s tem imenom že obstaja.",
    incomplete: "Izpolniti morate vsa zahtevana polja.",
    confirmCancelText: "Ali želite preklicati to prijavo?",
    confirmCategoryChange: "Ali želite spremeniti kategorijo prijave?",
    remindParticipation: "Opomni",
    remindParticipationConfirmation: "Ali želite opomniti tekmovalce, da potrdijo svojo prisotnost?",
    remindersSent: "Opomniki poslani",
    confirmDeleteText: "Ali želite izbrisati to prijavo?",
    noCycleForApplicationType: "Prijave za ta tip prijave so trenutno zaprte.",
    unofficial: "Neuradni rezultat"
  },
  payment: {
    receiver: "Prejemnik",
    address: "Naslov",
    bank: "Banka",
    subject: "Namen plačila",
    instructions: "Za potrditev vaše prijave morate poravnati prijavnino. Podatki za plačilo se nahajajo spodaj. Po plačilu nam preko spodnjega obrazca pošljite potrdilo o plačilu. Prijavnine ne vračamo, razen v primeru višje sile. Če se na dan tekmovanja ne boste izkazali s primernimi dokumenti (osebni dokument in izpisek iz Vulkana) in s tem dokazali da izpolnjujete pogoje za tekmovanje, ter zato ne boste smeli tekmovati vam prijavnine ne bomo vrnili.",
    uploadConfirmation: "Naloži potrdilo",
    uploadError: "Prišlo je do napake pri nalaganju potrdila"
  },
  competitor: {
    name: "Ime",
    department: "Gasilska enota",
    shirtSize: "Velikost majice",
    shirt: "Majica",
    participation: "Prisotnost",
    checkedIn: "Check-in",
    email: "E-pošta",
    dateOfBirth: "Datum rojstva",
    address: "Naslov",
    country: "Država",
    telephone: "Telefon",
    bestTime: "Najboljši čas",
    applications: "Prijave",
    alreadyCheckedin: "Ta tekmovalec je že prijavljen na to tekmovanje",
    roles: "Vloge"
  },
  profile: {
    title: "Profil",
    firstname: "Ime",
    lastname: "Priimek",
    email: "E-pošta",
    dateofbirth: "Datum rojstva",
    gender: "Spol",
    address: "Naslov (ulica, poštna številka in kraj)",
    telephone: "Telefonska številka",
    password: "Geslo",
    repeatpassword: "Ponovite geslo",
    male: "Moški",
    female: "Ženski",
    search: "Za dodajanje tekmovalcev vnesite e-poštni naslov",
    saved: "Podatki o profilu shranjeni"
  },
  events: {
    ParticipationConfirmed: "Prisotnost potrjena",
    ApplicationFiled: "Prijava oddana",
    PaymentUploaded: "Plačilo naloženo",
    PaymentConfirmed: "Plačilo potrjeno",
    ApplicationCanceled: "Prijava preklicana"
  },
  server: {
    title: "Strežnik",
    requests: "Zahteve",
    logs: "Beležke",
    requestsPerMinute: "Zahtev na minuto",
    responseTime: "Odzivni čas",
    emailFilter: "Filter e-pošte",
    clients: "Uporabnikov"
  },
  competition: {
    title: "Tekmovanje",
    organizer: "Organizator",
    organizerAddress: "Naslov organizatorja"
  },
  applicationCycles: {
    title: "Prijavni cikli",
    startTime: "Začetek",
    endTime: "Konec",
    amount: "Vsota",
    paymentByTransfer: "Plačilo z nakazilom"
  },
  races: {
    title: "Dirke",
    race: "Dirka",
    name: "Ime",
    previous: "Prejšnja dirka",
    maximalRuns: "Maksimalno prijav",
    assignStartNumbers: "Dodeli štartne številke",
    evaluationSheets: "Ocenjevalni listi",
    chooseRed: "Izberi rdeče",
    chooseBlue: "Izberi modre",
    publicDisplay: "Javno",
    maximalNumberOfRuns: "Največje število prijav",
    previousRace: "Prejšna dirka",
    startNumberOffset: "Zamik štartnih številk",
    startList: "Štartna lista",
    confirmRunDelete: "Ali želite izbrisati izbrane štarte?",
    announcement: "Razglasitev"
  },
  categories: {
    title: "Kategorije",
    order: "Vrstni red",
    label: "Oznaka",
    name: "Ime"
  },
  penalities: {
    title: "Kazni",
    description: "Opis",
    discipline: "Disciplina",
    penalityString: "Pribitek",
    amount: "Količina",
    totalAdditionalTime: "Dodaten čas",
    removeConfirmText: "Želite odstraniti to kazen?",
    copyFromCompetition: "Kopiraj iz tekmovanja"
  },
  runs: {
    startNumber: "Štartna št.",
    totalTime: "Skupni čas",
    disqualification: "Diskvalifikacija",
    time: "Čas",
    place: "Mesto",
    additionalTime: "Dodatni čas"
  },
  contact: {
    title: "Kontakt"
  },
  results: {
    title: "Rezultati",
    notReadyToStart: "Ni pripravljen na štart"
  },
  role: {
    title: "Vloga"
  },
  referee:{
    title: "Sodnik",
    unsavedChangesMessage: "En od štartov ima neshranjene spremembe. Ali želite nadaljevati?"
  },
  messages: {
    messages: "Obvestila",
    message: "Obvestilo",
    title: "Naslov",
    text: "Besedilo",
    start: "Začetek",
    end: "Konec",
    location: "Lokacija",
    public: "Javno",
    confirmRemove: "Ali želite izbrisati to obvestilo?",
    showMap: "Prikaži zemljevid"
  }
}
